import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

import { env } from '@/shared/config'

import { ChunkErrorBoundary } from '@/app/providers'


/** Available to every route's `beforeLoad` and `loader`. */
type RouterContext = {
  queryClient: QueryClient
}

const RouterDevtools = lazy(() =>
  import('@tanstack/react-router-devtools').then((module) => ({
    default: module.TanStackRouterDevtools,
  })),
)

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: () => <div className="p-8">Not found</div>,
})

function RootLayout() {
  return (
    <>
      {/* A rejected lazy import after a deploy must offer a reload, not blank. */}
      <ChunkErrorBoundary>
        <Outlet />
      </ChunkErrorBoundary>

      {env.isDev && (
        <Suspense fallback={null}>
          <RouterDevtools position="bottom-right" />
        </Suspense>
      )}
    </>
  )
}
